

    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import Loader from "@/views/Loader.vue"
    import { ApiClient } from "@/utilities/ApiClient";
    import { EmployeeWithDefaultCheckInTimeVM, IEmployeeWithDefaultCheckInTimeVM } from "@/model/Api/VM/EmployeeWithDefaultCheckInTimeVM";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Watch } from "vue-property-decorator";
    import { Utils } from "@/utilities/Utils";

    @Component({
        components: {
            ApiButton
        }
    })

    export default class ConfirmBookingModal extends Vue {

        private booking = new BookingVM();
        private employees: Array<IEmployeeWithDefaultCheckInTimeVM> = [];
        private buttonIsDisabled: boolean = true;
        private checked: boolean = false;
        private loaderActive: boolean = false;

        @Watch("checked")
        onChanged(newValue: any, oldValue: any) {
            if (this.checked === true) {
                this.checked = newValue
                return this.buttonIsDisabled = false
            }
            if (this.checked === false) {
                this.checked = newValue
                return this.buttonIsDisabled = true
            }
        }

        async showFromBookings(booking: BookingVM) {
            console.log("showFromBookings")
            this.booking.update(booking);
            await this.loadEmployees();
            this.$bvModal.show("confirmBookingModal");
        }

        async showFromModal(booking: BookingVM) {
            console.log(booking)
            this.booking.update(booking);
            await this.loadEmployees();
            this.$bvModal.show("confirmBookingModal");
        }

        async loadEmployees() {
            this.employees = [];
            const response = await ApiClient.get(`/Api/Booking/EmployeesWithDefaultCheckInTimes?bookingID=${this.booking.id}`);
            this.employees.push(...response.map((e: IEmployeeWithDefaultCheckInTimeVM) => new EmployeeWithDefaultCheckInTimeVM(e)));
        }

        cancel() {
            this.reset();
            this.$emit("refreshSearch");
            this.$bvModal.hide("confirmBookingModal");
        }

        async submitRequest(event: Event) {
            this.booking.statusID = 5;
            this.loaderActive = Utils.showLoader();
            const response = await ApiClient.post("/Api/Booking/ConfirmBooking", this.booking.id, event);
            if (response.message === "ok") {
                //await ApiClient.post("/Api/Report/hotelConfirmedItinerary", this.booking.id, event)
                this.loaderActive = Utils.hideLoader();
                toastr.success("Booking Confirmed");
                this.reset();
                this.$bvModal.hide("bookingModal");
                this.$bvModal.hide("confirmBookingModal");
                this.$emit("refreshSearch");
            }
        }

        reset() {
            this.checked = false;
            this.buttonIsDisabled = true;
            Utils.resetObject(this.booking);
            this.employees = [];
        }


    }

